import { inject, Injectable, signal } from '@angular/core';
import { StorageService } from '@/app/services/storage/storage.service';

/** Bump the suffix when the tour content changes enough to be worth re-showing. */
const SEEN_STORAGE_KEY = 'groups-whats-new-seen-v1';

@Injectable({
  providedIn: 'root',
})
export class GroupsWhatsNewService {
  private readonly storage = inject(StorageService);

  readonly isOpen = signal<boolean>(false);

  openIfUnseen(): void {
    if (this.hasSeen()) {
      return;
    }
    this.isOpen.set(true);
  }

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
    this.storage.setAndString(SEEN_STORAGE_KEY, true);
  }

  hasSeen(): boolean {
    return this.storage.getAndParse<boolean>(SEEN_STORAGE_KEY) === true;
  }
}
